import { createContext, ReactNode, useState } from 'react';

import { StepType } from '@/models/MultiStepFormProps';

type MultiStepFormContextProps = {
  currentStep: number;
  steps: StepType[];
  handleNext: () => void;
  handlePrevious: () => void;
  handleAddSteps: (steps: StepType[]) => void;
  resetCurrentStep: () => void;
};

type MultiStepFormProviderProps = {
  children: ReactNode;
};

export const MultiStepFormContext = createContext(
  {} as MultiStepFormContextProps,
);

export default function MultiStepFormProvider({
  children,
}: MultiStepFormProviderProps) {
  const [currentStep, setCurrentStep] = useState(0);
  const [steps, setSteps] = useState<StepType[]>([]);

  function resetCurrentStep() {
    setCurrentStep(0);
  }

  function handleNext() {
    setCurrentStep((oldState) => oldState + 1);
  }

  function handlePrevious() {
    setCurrentStep((oldState) => oldState - 1);
  }

  function handleAddSteps(step: StepType[]) {
    setSteps(step);
  }

  return (
    <MultiStepFormContext.Provider
      value={{
        currentStep,
        steps,
        handleNext,
        handlePrevious,
        handleAddSteps,
        resetCurrentStep,
      }}
    >
      {children}
    </MultiStepFormContext.Provider>
  );
}
